import { render } from "./Citation.vue?vue&type=template&id=e34e1692"
import script from "./Citation.vue?vue&type=script&lang=js"
export * from "./Citation.vue?vue&type=script&lang=js"

import "./Citation.vue?vue&type=style&index=0&id=e34e1692&lang=css"

import exportComponent from "/opt/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QField});
